import { Button, Flex, FormControl, FormLabel, Switch } from '@chakra-ui/react'
import { CreateFlexGroup, UpdateFlexGroup } from 'BrokerTsLib/src/dtos'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { Card } from '@/components/Card'
import { FormGroup } from '@/components/FormGroup'
import { InputGroup } from '@/components/InputGroup'
import { SwitchControl } from '@/components/SwitchControl'
import { TextareaGroup } from '@/components/TextareaGroup'

export const FlexGroupForm = ({
  flexGroup,
  create,
  onSubmit,
  leftButton,
}: {
  flexGroup: UpdateFlexGroup | CreateFlexGroup
  create?: boolean
  onSubmit: (data: UpdateFlexGroup) => void
  leftButton?: React.ReactNode
}) => {
  const methods = useForm<UpdateFlexGroup>({
    defaultValues: { ...flexGroup },
  })
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = methods

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Card w="2xl" margin="0 auto" p={6}>
          <Flex flexDir="column" gap={6}>
            <FormGroup>
              <FormControl isRequired isInvalid={!!errors.name}>
                <FormLabel>Název</FormLabel>
                <InputGroup
                  id="name"
                  placeholder="Název"
                  errors={errors.name}
                  {...register('name', {
                    required: 'Zadejte název',
                  })}
                />
              </FormControl>

              <FormControl w={'100%'}>
                <FormLabel>Popis</FormLabel>
                <TextareaGroup
                  w={'100%'}
                  id="description"
                  placeholder="Popis"
                  errors={errors.description}
                  {...register('description')}
                />
              </FormControl>

              {!create && (
                <FormControl>
                  <FormLabel>Aktivní</FormLabel>
                  <SwitchControl>
                    <FormLabel
                      fontSize={'md'}
                      htmlFor="active"
                      variant="switch"
                    >
                      Ne
                    </FormLabel>
                    <Switch id="active" size="md" {...register('valid')} />
                    <FormLabel
                      fontSize={'md'}
                      htmlFor="active"
                      variant="switch"
                    >
                      Ano
                    </FormLabel>
                  </SwitchControl>
                </FormControl>
              )}
            </FormGroup>
            <Flex justifyContent={'space-between'}>
              {leftButton}
              <Button
                colorScheme="primary"
                isLoading={isSubmitting}
                type="submit"
                marginLeft={'auto'}
              >
                {create ? 'Vytvořit flexibilní skupinu' : 'Uložit'}
              </Button>
            </Flex>
          </Flex>
        </Card>
      </form>
    </FormProvider>
  )
}
